import Constants from '../utils/consts';
import Utils from '../utils/utils';
import Cookies from 'universal-cookie';

var db = new Cookies().get('db', {path: '/' });
var http = require('follow-redirects').https;
var fs = require('fs');
var qs = require('querystring');

// isClass: se è 1 non inserisce la riga nella tabella notifications, ma manca solo la notifica
export default async function addNotification(uname, token, type, subjectId, title, body, bodyFull, isClass) {
    return new Promise(function (resolve, reject) {

        var options = {
        'method': 'POST',
        'hostname': Constants.ipAddress,
        'path': Constants.apisFolder + 'addNotificationNew2.php',
        'headers': {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cookie': 'uid=e02675a1a7516909792f6850dffcd5fe'
        },
        'maxRedirects': 20
        };

        var req = http.request(options, function (res) {
        var chunks = [];

        res.on("data", function (chunk) {
            chunks.push(chunk);
        });

        res.on("end", function (chunk) {
            var body = Buffer.concat(chunks);
            const resp = JSON.parse(body.toString());
            resolve(resp);
        });

        res.on("error", function (error) {
            console.error(error);
        });
        });

        var postData = qs.stringify({
        'token': token,
        'uname': uname,
        'type': type,
        'subjectId': subjectId,
        'title': Utils.escapeString(title),
        'body': Utils.escapeString(body),
        'bodyFull': Utils.escapeString(bodyFull),
        'isClass': isClass,
        'db_name': db
        });

        req.write(postData);

        req.end();

        
    });
}
